import React from 'react';
import {
	styled,
	Form
} from 'ps-gui';

import { getPhrase } from '../../../data/phrases';
import { formatHtml } from '../../utils';
import PhoneNumber from '../../../components/phonenumber';

export default class PasswordChangeResult extends React.PureComponent {
	render() {
		const {passwordChangeAuthCode, createPasswordChangeAuthenticationCode} = this.props;

		return (
			<>
				<h1>{getPhrase('passwordReset')}</h1>
				<Form vertical onAction={createPasswordChangeAuthenticationCode} key="pwdReset2">
					<FormHint dangerouslySetInnerHTML={{ __html: formatHtml(getPhrase('passwordResetEmailSent').replace('$email', passwordChangeAuthCode.get('email'))) }} />
					<FormFooter>
						{getPhrase('troubleChangingPasswordOrSigningIn')}
						<Div marginTop="16px">
							<PhoneNumber preset="intergram" />
						</Div>
					</FormFooter>
				</Form>
			</>
		);
	}
}

const FormHint = styled.div`
	font-size: 16px;
	font-weight: 400;
	line-height: 30px;
	margin-bottom: 40px;
	color: ${props => props.theme.disabledTextColor};
`;

const Div = styled.div`
	margin-top: ${props => props.marginTop};
`;

const FormFooter = styled.div`
	margin-top: 40px;
	padding-top: 24px;
	border-top: 1px solid ${props => props.theme.pageSeparatorColor};
`;
